import { createAsyncThunk } from '@reduxjs/toolkit'
import { ProjectController } from 'controllers/Project/ProjectController'
import { ShowException } from 'store/Application/appActions'
import { RootAppState } from 'store/configureStore'

export const startProjectManufacturabilityCheck = createAsyncThunk<
  Promise<void>,
  void,
  { state: RootAppState }
>(
  'project/start-manually-manufacturability-check',
  async (payload, thunkAPI) => {
    try {
      const projectController = new ProjectController()

      await projectController.StartProjectManufacturabilityCheck()
    } catch (err) {
      ShowException('delivery time estimation', err)
      thunkAPI.rejectWithValue(err)
    }
  },
)
